import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero, Loading } from "@/components/site/ui";
import { Reveal } from "@/components/brand";
import { Wifi, Waves, Car, Music, Flame, ShieldAlert, Clock, Utensils, Tv, Phone } from "lucide-react";

const GUIDE = [
  { icon: Wifi, title: "Wi-Fi", body: "Network: The D Guest. Ask your host for the password on arrival — it is never shared publicly." },
  { icon: Car, title: "Arrival & Parking", body: "Park in the driveway or as directed by your host. Please leave the street clear for neighbors." },
  { icon: Waves, title: "Pool & Spa", body: "The pool and spa are yours to enjoy. There is no lifeguard on duty — swim at your own risk and supervise children at all times." },
  { icon: Utensils, title: "Food & Beverages", body: "Enjoy the kitchen and bar areas. Rosemary cocktails and mocktails can be requested through concierge." },
  { icon: Music, title: "Music & Atmosphere", body: "Set the mood with a lighting theme and soundtrack request. Please respect quiet hours from 10PM to 8AM." },
  { icon: Flame, title: "Grill", body: "The grill is available with the Grill Package or by request. Please let it cool fully before covering." },
  { icon: Tv, title: "Televisions & Streaming", body: "Smart TVs are set up for streaming. Sign out of any personal accounts before checkout." },
  { icon: Clock, title: "Checkout", body: "Checkout is at 11:00 AM. Late checkout can be arranged in advance through concierge." },
  { icon: ShieldAlert, title: "Safety & Emergency", body: "In any emergency, call 911 first, then notify your host. First-aid supplies are in the main bathroom." },
  { icon: Phone, title: "Contact the Host", body: "Your host is a message away through the concierge system in your guest portal." },
];

export default function ResortGuide() {
  const [qrs, setQrs] = useState([]);
  useEffect(() => {
    const kinds = ["house-guide", "wifi", "concierge", "gallery"];
    Promise.all(kinds.map((k) => api.get(`/qr/${k}`).then((r) => r.data).catch(() => null)))
      .then((r) => setQrs(r.filter(Boolean)));
  }, []);
  return (
    <div>
      <PageHero eyebrow="Everything You Need" title="Resort Guide" subtitle="Your digital house guide to The D." compact />
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="grid sm:grid-cols-2 gap-4">
          {GUIDE.map((g, i) => (
            <Reveal key={g.title} delay={(i % 2) * 0.06}>
              <div className="glass rounded-lg p-6 h-full" data-testid={`guide-${g.title.toLowerCase().replace(/\s|&/g, "")}`}>
                <g.icon className="text-gold mb-3" size={20} />
                <h3 className="font-serif text-2xl">{g.title}</h3>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{g.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        {qrs.length > 0 && (
          <div className="mt-14">
            <h3 className="font-serif text-3xl text-center mb-8">Scan to access</h3>
            <div className="flex flex-wrap justify-center gap-6">
              {qrs.map((q) => (
                <div key={q.kind} className="glass rounded-lg p-4 text-center">
                  <img src={q.png} alt={q.kind} className="h-28 w-28 rounded" />
                  <p className="text-[10px] tracking-label uppercase text-muted-foreground mt-2">{q.kind.replace("-", " ")}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
